import { useMutation, useQueryClient } from "@tanstack/react-query";

import { TCustomQueryProps } from "@/common/type/hooks.types";
import { ServiceReportFile } from "@/modules/serviceOrdering/interfaces/ServiceReportFile";

import { updateManyServiceReportFiles } from "../services";

export const useUpdateManyServiceReportFiles = ({
  handleSuccess,
}: Partial<TCustomQueryProps<ServiceReportFile[]>> = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serviceReportFiles: ServiceReportFile[]) =>
      updateManyServiceReportFiles(serviceReportFiles),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["getServiceById"],
      });

      handleSuccess?.(variables);
    },
    onError: (error: Error) => {
      console.error(
        "Error when updating many service report files:",
        error?.message
      );
    },
  });
};
